import { withTranslation } from "react-i18next";

import ProductList from './ProductList';

export default withTranslation(undefined, { withRef: true })(ProductList);